var React = require('react');

function Left (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.78033 9.7803C5.48744 10.0732 5.01256 10.0732 4.71967 9.7803L0.469668 5.53033C0.176777 5.23744 0.176777 4.76256 0.469668 4.46967L4.71967 0.219668C5.01256 -0.0732225 5.48744 -0.0732225 5.78033 0.219668C6.0732 0.512558 6.0732 0.987438 5.78033 1.28033L2.06066 5L5.78033 8.7197C6.0732 9.0126 6.0732 9.4874 5.78033 9.7803Z","fill":"currentColor","fillOpacity":"0.88"}));
}

Left.defaultProps = {"viewBox":"0 0 6 10","fill":"none"};

module.exports = Left;

Left.default = Left;
